<div class="content">
    <div class="card">
      <div class="card-header header-elements-inline" [ngBusy]="busy">
        <h6 class="card-title">Liste des banquiers</h6>
  
        <div class="heading-elements">
          <button
            [routerLink]="['/add-banker']"
            type="button"
            class="btn btn-info btn-xs"
          >
            <i class="icon-plus2 position-left"></i>Ajouter un banquier
          </button>
        </div>
      </div>
  
      <br />
  
      <div class="card-body">
        <table class="table perso-table" datatable [dtOptions]="dtOptions">
          <thead>
            <tr>
              <th>#</th>
              <th>Nom</th>
              <th>Email</th>
              <th>Téléphone</th>
              <th>Banque</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody></tbody>
        </table>
      </div>
    </div>
  </div>
  